<template>
  <div>
    <div class="d-flex mb-3">
      <h3
        style="font-weight: 500"
        class="mr-3"
      >
        Gestion des utilisateurs
      </h3>
      <span class="smaller-text d-flex align-center pr-3">
        {{ numInfos }}
      </span>
      <ClosableDialog
        v-if="maxUsers === undefined || numUsers < maxUsers"
        icon="person_add"
        ref="newUserDialog"
      >
        <UserForm
          :organization="organization"
          @saved="saved()"
        />
      </ClosableDialog>
    </div>
    <div class="d-flex justify-center pa-3" v-if="loading">
      <v-progress-circular
        indeterminate
        :size="30"
        :width="4"
      />
    </div>
    <div
      v-else
      v-for="user in organization.users"
      :key="user.id"
    >
      <v-card
        outlined
        elevation="1"
        class="pa-2 d-flex align-center justify-space-between"
      >
        <div>
          <span
            class="ml-1"
          >
            {{ user.firstName }}
          </span>
          <span
            class="ml-1"
          >
            {{ user.lastName }}
          </span>
          <span
            class="ml-2 smaller-text"
          >
            {{ user.id }}
          </span>
        </div>
        <div class="d-flex">
          <UserRoles class="mr-2" :roles="user.roles" />
          <ClosableDialog icon="settings" ref="updateUserDialog">
            <UserForm
              :user="user"
              :organization="organization"
              @saved="saved()"
            />
          </ClosableDialog>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import ClosableDialog from '@/shared/components/dialog/ClosableDialog';
import UserForm from './UserForm';
import UserRoles from './UserRoles';

export default {
  name: 'UserManagement',
  components: { ClosableDialog, UserForm, UserRoles },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    organization() {
      this.update();
    },
  },
  data() {
    return {
      maxUsers: undefined,
      numUsers: undefined,
      numInfos: '',
    };
  },
  methods: {
    update() {
      if (!this.organization.users) return;

      this.numUsers = this.organization.users.length;
      this.maxUsers = this.organization.maxUsers;

      if (this.maxUsers) {
        this.numInfos = `${this.numUsers}/${this.maxUsers}`;
      } else {
        this.numInfos = `${this.numUsers}`;
      }
    },
    saved() {
      if (this.$refs.newUserDialog) {
        this.$refs.newUserDialog.close();
      }
      this.closeUpdateUserDialogs();
      this.$emit('saved');
    },
    closeUpdateUserDialogs() {
      try {
        this.$refs.updateUserDialog.forEach(dialog => {
          try {
            dialog.close();
          } catch {
            // ignore, we need to try to call close on all dialog
          }
        });
      } catch {
        // ignore, easier the check if it exists, if it's a list, etc.
      }
    },
  },
};
</script>
<style>
.smaller-text {
  font-size: 12px;
  font-weight: 300;
}
</style>
